import { useState, useEffect, useCallback } from 'react';
import './Games.css';

const CARD_SYMBOLS = ['🌙', '⭐', '🔮', '🌸'];

export default function CardGame({ theme = 'default' }) {
    const [cards, setCards] = useState([]);
    const [flippedIndexes, setFlippedIndexes] = useState([]);
    const [matchedPairs, setMatchedPairs] = useState([]);
    const [moves, setMoves] = useState(0);
    const [message, setMessage] = useState('');

    const initGame = useCallback(() => {
        const pairs = [...CARD_SYMBOLS, ...CARD_SYMBOLS];
        const shuffled = pairs.sort(() => Math.random() - 0.5);
        setCards(shuffled);
        setFlippedIndexes([]);
        setMatchedPairs([]);
        setMoves(0);
        setMessage('');
    }, []);

    useEffect(() => {
        initGame();
    }, [initGame]);

    useEffect(() => {
        if (flippedIndexes.length === 2) {
            const [first, second] = flippedIndexes;

            if (cards[first] === cards[second]) {
                setMatchedPairs(prev => [...prev, cards[first]]);
                setFlippedIndexes([]);
                setMessage('🎉 짝을 찾았어요!');
                setTimeout(() => setMessage(''), 1000);

                if (matchedPairs.length + 1 === CARD_SYMBOLS.length) {
                    setTimeout(() => {
                        setMessage('🎊 완료! 다시 시작~');
                        setTimeout(initGame, 1500);
                    }, 500);
                }
            } else {
                setTimeout(() => {
                    setFlippedIndexes([]);
                }, 800);
            }
        }
    }, [flippedIndexes, cards, matchedPairs.length, initGame]);

    const handleCardClick = (e, index) => {
        e.preventDefault();
        if (flippedIndexes.length >= 2) return;
        if (flippedIndexes.includes(index)) return;
        if (matchedPairs.includes(cards[index])) return;

        setFlippedIndexes(prev => [...prev, index]);
        setMoves(prev => prev + 1);
    };

    const isCardVisible = (index) => {
        return flippedIndexes.includes(index) || matchedPairs.includes(cards[index]);
    };

    const themeClass = theme === 'daetong' ? 'theme-daetong' : theme === 'lighthouse' ? 'theme-lighthouse' : '';

    return (
        <div className={`game-container card-game ${themeClass}`}>
            <div className="game-title">🎴 같은 카드를 찾으세요!</div>
            <div className="game-stats">
                <span>시도: {moves}회</span>
                <span>찾은 짝: {matchedPairs.length}/{CARD_SYMBOLS.length}</span>
            </div>

            <div className="card-grid">
                {cards.map((symbol, index) => (
                    <div
                        key={index}
                        className={`card ${flippedIndexes.includes(index) ? 'flipped' : ''} ${matchedPairs.includes(symbol) ? 'matched' : ''}`}
                        onClick={(e) => handleCardClick(e, index)}
                        onTouchEnd={(e) => handleCardClick(e, index)}
                    >
                        {isCardVisible(index) ? symbol : '?'}
                    </div>
                ))}
            </div>

            <div className="game-message">{message}</div>
        </div>
    );
}
